import { createMuiTheme } from '@material-ui/core/styles';
import { PaletteOptions } from '@material-ui/core/styles/createPalette';
import { Overrides } from '@material-ui/core/styles/overrides';
import { TypographyOptions } from '@material-ui/core/styles/createTypography';

import {
    darkBlue,
    darkerGrey,
    darkGreen,
    darkGreenBlue,
    darkMediumBlue,
    darkMediumGrey,
    lightBlue,
    lightGreen,
    lightGrey,
    lightLightBlue,
    mediumBlue,
    mediumGreen,
    mediumLightBlue,
    mediumRed,
    white,
} from './_colors';

declare module '@material-ui/core/styles/createMuiTheme' {
    interface Theme {
        colors: {
            white: string;
            lightBlue: string;
            darkerGrey: string;
            darkMediumGrey: string;
            lightGrey: string;
            lightGreen: string;
        };
    }

    interface ThemeOptions {
        colors?: {
            white?: string;
            lightBlue?: string;
            darkerGrey?: string;
            darkMediumGrey?: string;
            lightGrey?: string;
        };
    }
}

const palette: PaletteOptions = {
    primary: {
        light: darkMediumBlue,
        main: darkBlue,
        dark: darkGreenBlue,
    },
    success: {
        main: mediumGreen,
        dark: darkGreen,
    },
    error: {
        main: mediumRed,
    },
    info: {
        light: lightLightBlue,
        main: mediumLightBlue,
        dark: mediumBlue,
    },
};

const colors = {
    white,
    lightBlue,
    darkerGrey,
    darkMediumGrey,
    lightGrey,
    lightGreen,
};

const overrides: Overrides = {
    MuiButton: {
        contained: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none',
            },
        },
        containedPrimary: {
            color: colors.white,
            backgroundColor: mediumGreen,
            borderRadius: 4,
            fontSize: 18,
            '&:hover': {
                backgroundColor: darkGreen,
            },
        },
        containedSecondary: {
            color: colors.white,
            backgroundColor: darkBlue,
            borderRadius: 4,
            '&:hover': {
                backgroundColor: mediumLightBlue,
            },
        },
    },
    MuiCircularProgress: {
        colorPrimary: {
            color: mediumGreen,
        },
    },
    MuiPaper: {
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            backgroundColor: white,
            padding: '48px',
            width: '100%',
            '&:focus': {
                outline: `${white} auto 0`,
            },
        },
        elevation1: {
            borderRadius: '8px',
            boxShadow:
                '0px 8px 24px 0px rgba(0,0,0,0.08), 0px 0px 0px 0px rgba(0, 0, 0, 0.08), 0px 0px 0px 0px rgba(0,0,0,0.08)',
        },
    },
    MuiLink: {
        root: {
            color: darkBlue,
            textDecoration: 'underline',
            fontWeight: 500,
        },
    },
    MuiTypography: {
        h5: {
            color: darkBlue,
            fontWeight: 500,
            fontSize: 24,
        },
        h6: {
            color: darkBlue,
            fontSize: 18,
            fontWeight: 'normal',
        },
    },
};

const typography: TypographyOptions = {
    fontFamily: 'Roboto',
};

export const appTheme = createMuiTheme({
    palette,
    colors,
    overrides,
    typography,
});
